import request from '@/utils/request'



export function getPage(condition, pagination) {
  return request({
    url: '/erp/terminal/inventory/page',
    method: 'post',
    data: { condition: condition, pagination: pagination }
  })
}

// 批量下拨列表数据
export function getTerminalOperationList(param) {
  return request({
    url: '/erp/terminal/inventory/getTerminalOperationList',
    method: 'post',
    data: param
  })
}

// 获取公司列表
export function getGroupListToTerminal(data) {
  return request({
    url: '/system/group/getGroupListToTerminal',
    method: 'post',
    data
  })
}

// 获取业务员接口
export function getUserListByLogin(data) {
  return request({
    url: '/system/admin/getUserListByLogin',
    method: 'post',
    data
  })
}


// 总部批量下拨 || 分公司批量下拨
export function allocateBatch(data) {
  return request({
    url: '/erp/terminal/inventory/allocateBatch',
    method: 'post',
    data
  })
}

// 总部单台下拨 || 分公司单台下拨
export function allocateOne(data) {
  return request({
    url: '/erp/terminal/inventory/allocateOne',
    method: 'post',
    data
  })
}

// 分公司批量回拨
export function callbackBatch(data) {
  return request({
    url: '/erp/terminal/inventory/callbackBatch',
    method: 'post',
    data
  })
}

// 分公司单台回拨
export function callbackOne(data) {
  return request({
    url: '/erp/terminal/inventory/callbackOne',
    method: 'post',
    data
  })
}
// 获取编辑数据
export function getTerminalDetail(id) {
  return request({
    url: `/erp/terminal/inventory/get`,
    method: 'get',
    params: { id }
  })
}

// 更新终端信息
export function updateTerminal(data) {
  return request({
    url: '/erp/terminal/inventory/saveOrUpdate',
    method: 'post',
    data
  })
}
// 终端信息审核
export function auditTerminal(data) {
  return request({
    url: '/erp/terminal/inventory/auditInfo',
    method: 'post',
    data
  })
}
